/** MY Secretary — license_number = Qualification 접두사 + 숫자만.
 *  접두사 = 자격단체(CA2016 4th Schedule + S.20G): MAICSA/MIA/MACS/MICPA/LS/SLS/SAA.
 *  ※ BC(Bar Council)는 'BC/S/1235' 슬래시 형식이라 '접두사+숫자' 모델과 달라 제외(전체 라이선스 직접 입력).
 *  ※ 접두사끼리 startsWith 충돌 없음(MIA↔MICPA, LS↔SLS 등 모두 비충돌) → 배열 순서 무관.
 */
export const MY_LICENSE_QUALIFICATION_PREFIXES = ['MAICSA', 'MIA', 'MACS', 'MICPA', 'LS', 'SLS', 'SAA'] as const;
export type MyQualificationPrefix = (typeof MY_LICENSE_QUALIFICATION_PREFIXES)[number] | '';

export const SECRETARY_LICENSE_FIELD_KEYS = [
    'license_number',
    'SecretaryLicenseNo',
    'LICENSE',
    'SECRETARY_LICENSE_NO',
    'LICENSENO',
    'LICENSE_NO',
    'MEMBER_LICENSE',
] as const;

export const SECRETARY_CERT_FIELD_KEYS = [
    'SecretaryCertificateNo',
    'SECRETARY_CERTIFICATE_NO',
    'secretaryCertificateNo',
    'PRACTICING_CERT',
    'MEMBER_PRACERTNO',
    'PRACCERT',
    'PRACTCERTNO',
] as const;

function firstFilledField(data: Record<string, unknown>, keys: readonly string[]): string {
    for (const key of keys) {
        const v = data[key];
        if (v != null && String(v).trim() !== '') return String(v).trim();
    }
    return '';
}

/** Contact 재선택 시 모든 별칭 키를 동일 값(빈 문자열 포함)으로 맞춤 */
export function applySecretaryLicenseAliases(record: Record<string, unknown>, license: string): void {
    const v = String(license ?? '').trim();
    for (const key of SECRETARY_LICENSE_FIELD_KEYS) {
        record[key] = v;
    }
}

export function applySecretaryCertificateAliases(record: Record<string, unknown>, cert: string): void {
    const v = String(cert ?? '').trim();
    for (const key of SECRETARY_CERT_FIELD_KEYS) {
        record[key] = v;
    }
}

export function splitMySecretaryLicense(combined: string): { prefix: MyQualificationPrefix; digits: string } {
    const raw = String(combined ?? '').trim();
    if (!raw) return { prefix: '', digits: '' };
    const upper = raw.toUpperCase();
    for (const p of MY_LICENSE_QUALIFICATION_PREFIXES) {
        if (upper.startsWith(p)) {
            const rest = raw.slice(p.length);
            return { prefix: p, digits: rest.replace(/\D/g, '') };
        }
    }
    return { prefix: '', digits: raw.replace(/\D/g, '') };
}

export function mergeMySecretaryLicense(prefix: string, digits: string): string {
    const d = String(digits ?? '').replace(/\D/g, '');
    const p = String(prefix ?? '').trim().toUpperCase();
    if (!p && !d) return '';
    if (!p) return d;
    return `${p}${d}`;
}

export function readSecretaryLicenseCombined(data: Record<string, unknown>): string {
    return firstFilledField(data, SECRETARY_LICENSE_FIELD_KEYS);
}

export function readSecretaryCertificateCombined(data: Record<string, unknown>): string {
    return firstFilledField(data, SECRETARY_CERT_FIELD_KEYS);
}
